import { Link } from "react-router-dom";
import { H4 } from "../../../AbstractElements";
// import CustomerAction from "../ActionCell/CustomerAction";

export const CustomerColumns =  [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px'
    },
     {
        name: <i className="fa fa-gears" style={{ fontSize: '15px' }}></i>,
        selector: row => row.action,
        cell: row => <Action row={row}  />,
        center: true,
        width: '55px',
    },
    {
        name: <H4>Enquiry ID</H4>,
        id: 'enquiryID',
        selector: row =>row.enquiryId,
        sortable: true,
        minWidth: '150px',
        wrap: true
    },
    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.name,
        sortable: true,
        minWidth: '150px',
        wrap: true
    },

    {
        name: <H4>Mobile No</H4>,
        selector: row => row.Mobile,
        id: 'mobile',
        sortable: true,
        minWidth: '160px',
    },
    {
        name: <H4>Product name</H4>,
        selector: row => row.product,
        id: 'product',
        sortable: true,
        minWidth: '160px',
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.Date,
        minWidth: '120px',
        cell: row => (
            <span
                className={` badge-${row.Status}`}
            >
                {row.Status}
            </span>
        ),
    },
    {
        name: <H4>Assigned To</H4>,
        selector: row => row.assigned,
        id: 'assigned',
        sortable: true,
        wrap: true,
        minWidth:'160px'
    },
    {
        name: <H4>Created On</H4>,
        selector: row => row.created,
        id: 'Create',
        minWidth: '160px',

        sortable: true,
        wrap: true,
    },
];
export const leadsColumns = [
  {
    name: <H4>Sl.No</H4>,
    selector: (row) => row.Si,
    minWidth: "70px",
  },

  {
    name: <H4>Lead ID</H4>,
    id: "leadID",
    selector: (row) => (
      <Link
        style={{ textDecoration: "underline" }}
        to={`${process.env.PUBLIC_URL}/lead-manage/leads-details?id=${row.id}`}
      >
        {row.leadId}
      </Link>
    ),
    sortable: true,
    minWidth: "150px",
    wrap: true,
  },

  {
    name: <H4>Name</H4>,
    id: "name",
    selector: (row) => row.name,
    sortable: true,
    minWidth: "140px",
    wrap: true,
  },

  {
    name: <H4>Mobile No</H4>,
    selector: (row) => row.Mobile,
    id: "mobile",
    sortable: true,
    minWidth: "160px",
  },

  {
    name: <H4>Status</H4>,
    selector: (row) => row.Status,
    minWidth: "120px",
    cell: (row) => (
      <span className={`badge-${row.Status}`}>
        {row.Status}
      </span>
    ),
  },

  {
    name: <H4>Expected Value</H4>,
    selector: (row) => row.expectedValue,
    id: "value",
    sortable: true,
    minWidth: "160px",
  },

  {
    name: <H4>Assigned To</H4>,
    selector: (row) => row.assigned,
    id: "assigned",
    sortable: true,
    wrap: true,
    minWidth: "160px",
  },

  {
    name: <H4>Created Date</H4>,
    selector: (row) => row.created,
    id: "Create",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
   {
    name: <H4>Next Follow-up</H4>,
    selector: (row) => row.nextFollowup,
    id: "Create",
    minWidth: "150px",
    sortable: true,
    wrap: true,
  },
];
export const duefollowUpColumns = (authState, handleStatusChange, handlestatusArchive) => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px'
    },

    {
        name: <H4>Lead ID</H4>,
        id: 'lead',
        selector: row =>
            row.leadId?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/lead-manage/leads-details?id=${row.id}`}>
                    {row.leadId}
                </Link> : 'N/A',
        sortable: true,
        wrap: true
    },
    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.name,
        sortable: true,
        wrap: true
    },

    {
        name: <H4>Assigned To</H4>,
        selector: row => row.assigned,
        id: 'assigned',
        sortable: true,
        wrap: true,

    },
    {
        name: <H4>Remarks</H4>,
        selector: row => row.remarks,
        id: 'reamrk',
        sortable: true,
        wrap: true,

    },
    {
        name: <H4>Next Follow-up</H4>,
        selector: row => row.nextFolloWDate,
        id: 'follow',
        sortable: true,
        wrap: true,

    },
    {
        name: <H4>Stage</H4>,
        selector: row => row.stage,
        cell: row => (
            <span
                className={` badge-${row.stage}`}
            >
                {row.stage}
            </span>
        ),
    },
   

];
export const followUpColumns = (authState,Action, handleStatusChange, handlestatusArchive) => [
    {
        name: <H4>Sl.No</H4>,
        selector: row => row.Si,
        width: '70px'
    },
    {
        name: <H4>Action</H4>,
        selector: row => <Action row={row}  />,
        width: '100px',
        center:true

    },

    {
        name: <H4>Lead ID</H4>,
        id: 'lead',
        selector: row =>
            row.leadId?
                <Link style={{ textDecoration: 'underline' }} to={`${process.env.PUBLIC_URL}/lead-manage/leads-details?id=${row.lead_id}`}>
                    {row.leadId}
                </Link> : 'N/A',
        sortable: true,
        wrap: true,
        minWidth: '150px',

    },
    {
        name: <H4>Name</H4>,
        id: 'name',
        selector: row => row.name,
        sortable: true,
        wrap: true
    },

    {
        name: <H4>Assigned To</H4>,
        selector: row => row.assigned,
        id: 'assigned',
        sortable: true,
        wrap: true,

    },
    {
        name: <H4>Remarks</H4>,
        selector: row => row.remarks,
        id: 'reamrk',
        sortable: true,
        wrap: true,

    },
    {
        name: <H4>Next Follow-up</H4>,
        selector: row => row.nextFolloWDate,
        id: 'follow',
        sortable: true,
        minWidth:'160px',
        wrap: true,

    },
    {
        name: <H4>Lead Stage</H4>,
        selector: row => row.stage,
        cell: row => (
            <span
                className={` badge-${row.stage}`}
            >
                {row.stage}
            </span>
        ),
    },
    {
        name: <H4>Status</H4>,
        selector: row => row.status,
        cell: row => (
            <span
                className={` badge-${row.status}`}
            >
                {row.status}
            </span>
        ),
    },
   

];